import TaskList from '../../../../../../components/TaskList'

function AssetMangementTab({ auditionbook }) {
  return <TaskList auditionbook={auditionbook} />
}

export default AssetMangementTab
